export const isDefined = <T>(value: T): value is Exclude<T, null | undefined> & NonNullable<T> => {
  return value != null;
};

export const isTruthy = <T>(value: T): value is Exclude<T, null | undefined | '' | false | 0> => {
  return Boolean(value);
};

export const isArray: (value: unknown) => value is readonly unknown[] = Array.isArray;
